import React from 'react';

const SquareLogo = () => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="2" width="18" height="18" rx="3" stroke="#737FA4" stroke-width="3"/>
            <path d="M8.60545 13.7289C8.27091 13.7289 8 13.4562 8 13.1203V8.88207C8 8.54617 8.27091 8.27344 8.60545 8.27344H12.85C13.1855 8.27344 13.4555 8.54617 13.4555 8.88207V13.1203C13.4555 13.4562 13.1855 13.7289 12.85 13.7289H8.60545Z" fill="#737FA4"/>
        </svg>
    )
}

export default SquareLogo;